<!-- 汇率查询 -->
<template>
  <div class="interCash">
    <order-search
      ref="orderSearch"
      :searchColumns="searchColumns"
      :searchForm="searchForm"
      :columnList="columnList"
      :api="api"
      @searchCompanyChange="searchCompanyChange"
      :showFooter="1 == 1"
      :footerTotalCols="footerTotalCols"
    ></order-search>
  </div>
</template>

<script>
  import orderSearch from '../components/orderSearch';
  import IG_API from '@/api/masterData/intersetGroup.js';
  export default {
    name: 'interCash',
    components: {
      orderSearch,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('interPool.column.orderCompany'),
            prop: 'orderCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'searchCompanyChange',
            filterable: true,
          },
          {
            // 部门
            prop: 'orderDepartmentCode',
            name: this.$t('interPool.column.orderDepartment'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            name: this.$t('interPool.search.interestDateStart'),
            prop: 'interestDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('interPool.search.interestDateEnd'),
            prop: 'interestDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 部门组
            prop: 'interestGroupCodes',
            name: '部门组',
            type: 'ajaxSelect',
            apiUrl: IG_API.INTERSET_GROUP_LIST,
            apiData: {},
            clearable: true,
            filterable: true,
            valueKey: 'interestGroupCode',
            labelKey: 'interestGroupName',
            method: 'post',
            multiple: true,
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          {
            field: 'orderCompanyName',
            title: this.$t('interPool.column.orderCompany'),
          },
          {
            field: 'orderDepartmentName',
            title: this.$t('interPool.column.orderDepartment'),
          },
          {
            field: 'orderInterestGroupName',
            title: '部门组',
          },
          {
            field: 'interestDate',
            title: this.$t('interPool.column.interestDate'),
          },
          {
            field: 'interestPaymentAmount',
            title: this.$t('interPool.column.interestPaymentAmount'),
          },
          {
            field: 'interestReceiptAmount',
            title: this.$t('interPool.column.interestReceiptAmount'),
          },
          {
            field: 'remark',
            title: this.$t('interPool.column.remark'),
          },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: { price: ['interestPaymentAmount', 'interestReceiptAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        companyList: [],
        departmentList: [],
        api: {
          query: 'QUERY_INTRCASH_PAGE',
          export: 'EXPORT_INTRCASH',
        },
        searchForm: {
          orderCompanyCode: null,
          orderDepartmentCode: null,
          interestDateStart: null,
          interestDateEnd: null,
          interestGroupCodes: [],
          orderCode: 'CASH',
        },
      };
    },
    mounted() {
      this.getCompany();
      if (Object.keys(this.$route.query).length > 0) {
        let query = this.$route.query;
        this.searchForm.orderCompanyCode = query.orderCompanyCode;
        if (query.departmentType === '1') {
          this.searchForm.interestGroupCodes = [query.orderDepartmentCode];
        } else {
          this.searchForm.orderDepartmentCode = query.orderDepartmentCode;
        }
        this.searchForm.interestDateStart = this.searchForm.interestDateEnd = query.interestDate;
        this.getDepartment(this.searchForm.orderCompanyCode);
        this.$refs.orderSearch.searchBtnClick();
      }
    },
    methods: {
      // 获取公司数据
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      // 获取部门数据
      async getDepartment(companyCode) {
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.departmentList = res;
          }
        } else {
          this.departmentList = [];
        }
      },
      searchCompanyChange(val) {
        // 切换公司
        this.searchForm.orderDepartmentCode = null;
        this.getDepartment(val.val);
      },
    },
  };
</script>
